// Mobile sticky buy bar for the product page.
// Shows itself once the main add-to-cart button has scrolled out of view above the viewport,
// and hides again when the button is back in view. Its button clicks the main add-to-cart
// button, so the product form's own add-to-cart flow (cart drawer, errors) is reused.
class SStickyBuy extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const scope = this.closest('[data-product-form]') || document;
    const target = scope.querySelector('button[name="add"], [data-sticky-buy-anchor]');
    if (!target) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', passed);
      this.setAttribute('aria-hidden', passed ? 'false' : 'true');
      this.inert = !passed;
    });
    this.#observer.observe(target);

    this.querySelector('[data-sticky-buy-button]')?.addEventListener('click', () => {
      const add = scope.querySelector('button[name="add"]');
      if (add) add.click();
    });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
